import axios from 'axios';
import { array, number, object, string } from 'yup';

import { apiConfig } from '@constants';

import { alertShape } from '../../../constants/types/api/alertShape';
import { toQueryString } from '../../../helpers/StringUtils';

const alertsDetailArgumentsSchema = object({
  alertId: string().required(),
  language: string().default('en-US'),
});

/**
 * This schema follows Weather Alerts Detail - v3.0 (https://docs.google.com/document/d/16cYge1VXtLz68MnZKqsYXnPSOJroN8LdfufK3_ZcWo8)
 */
const alertsDetailSchema = object({
  alertDetail: object({
    ...alertShape,
    texts: array().of(
      object({
        languageCode: string().nullable(),
        description: string().nullable(),
        instruction: string().nullable(),
        overview: string().nullable(),
      }),
    ),
    polygon: object({
      lat: number().nullable(),
      lng: number().nullable(),
    }).nullable(),
    synopsis: string().nullable(),
    supplement: object().nullable(),
  }),
}).nullable();

const getAlertDetailApiUrl = ({ alertId, language }: { alertId: string; language: string }) =>
  [
    apiConfig.TWC_API_BASE,
    apiConfig.TWC_API_ALERTS_DETAIL,
    toQueryString({
      alertId,
      language,
      format: 'json',
      apiKey: apiConfig.TWC_API_KEY,
    }),
  ].join('');

export const getAlertsDetail = async (alertId: string) => {
  const validateArguments = await alertsDetailArgumentsSchema.validate({
    alertId,
  });

  const url = getAlertDetailApiUrl(validateArguments);
  const { data } = await axios.get(url);

  return alertsDetailSchema.validate(data);
};
